<template>
  <div class="contactWay max-width">
    
    <v-afficheSidebar></v-afficheSidebar>

    <div class="cw_model max-width">
      <!-- <iframe src="http://www.chbaojia.com/#/bj/2677/123456/pidenv_hbhb" width="1200" height="680"></iframe> -->

      <template v-for='item in cw_list'>
			<div :key='item.id' class='cw_mod_view'>
				<div class='cw_mod_vi_title font-16 color-body'>{{item.title}}</div>
				<div class='cw_mod_vi_line font-14 color-prompt-deep'>
					<div class='cw_mod_vi_li_name'>电话:</div>
					<div class='cw_mod_vi_li_value'>{{item.phone[0]}}</div>
				</div>
				<div v-if='item.phone[1]' class='cw_mod_vi_line font-14 color-prompt-deep'>
					<div class='cw_mod_vi_li_name'></div>
					<div class='cw_mod_vi_li_value'>{{item.phone[1]}}</div>
				</div>
				<div v-if='item.qq' class='cw_mod_vi_line font-14 color-prompt-deep'>
					<div class='cw_mod_vi_li_name'>QQ:</div>
					<div class='cw_mod_vi_li_value'>{{item.qq}}</div>
				</div>
				<div v-if='item.name' class='cw_mod_vi_line font-14 color-prompt-deep'>
					<div class='cw_mod_vi_li_name'>联系:</div>
					<div class='cw_mod_vi_li_value'>{{item.name}}</div>
				</div>
				<div v-if='item.qq' class='cw_mod_vi_btn bgcolor-gradient-right font-12 no-copy' 
					 :data-qq='item.qq' 
					 @click='func_qq'>
					<img class='cw_mod_vi_btn_icon' src='@/assets/icon/qq.png' />
					QQ交谈
				</div>
			</div>
		</template>

      <div class="cw_title color font-20">广东新彩航印刷有限公司</div>
      <div class="cw_line font-15 color-body">
        <div class="cw_li_name">工厂地址：</div>
        <div class="cw_li_value font-hover">
          广东省佛山市南海区和顺顺福东路1号宝鼎智造产业园6号楼首层
        </div>
      </div>
      <!-- <div class="cw_line font-15 color-body">
        <div class="cw_li_name">业务部：</div>
        <div class="cw_li_value font-hover">
          广东省佛山市南海区桂城万达中心E座1810
        </div>
      </div> -->
      <div class='cw_line font-15 color-body'>
			<div class='cw_li_name'>电话：</div>
			<div class='cw_li_value font-hover'>0757-85101650</div>
		</div>
      <div class="cw_line font-15 color-body">
        <div class="cw_li_name">企业QQ：</div>
        <div class="cw_li_value font-hover">800180939</div>
      </div>
      <div class="cw_line font-15 color-body">
        <div class="cw_li_name">投诉建议：</div>
        <div class="cw_li_value font-hover">1198650274@qq.com</div>
      </div>

      <div class="biaoge">
        <div class="daohang" v-for="(item, index) in this.lianxi" :key="index">
          <div class="details1">
            {{ item.quyu }}
          </div>
          <!-- <div class="details">
            {{ item.name }}
          </div> -->
           <div class="details">
            {{ item.weixin }}
          </div>
           <div class="details">
            {{ item.QQ }}
          </div>
           <!-- <div class="details">
            {{ item.dianhua }}
          </div> -->
        </div>
      </div>

      <!-- <div class='cw_line font-15 color-body'>
			<div class='cw_li_name'>商务合作邮箱：</div>
			<div class='cw_li_value font-hover'>119865027@qq.com</div>
		</div> -->
      <!-- <div class='cw_line font-15 color-body'>
			<div class='cw_li_name'>在线报价下单：</div>
			<div class='cw_li_value font-hover'>http://www.yin2015.com</div>
		</div> -->
      <img class="cw_map no-copy" src="@/assets/public/staticimage.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "contactWay",
  components: {},
  data() {
    return {
      lianxi: [
        {
          quyu: "业务区域",
          name: "负责人",
          weixin: "手机微信",
          QQ: "QQ",
          dianhua: "电话",
        },
        {
          quyu: "罗冲围,汕头市,汕尾市,揭阳市",
          name: "黄锦妍",
          weixin: "13703018379",
          QQ: "2850259780",
          dianhua: "0757-85101650",
        },
        {
          quyu: "松柏店,阳江市,云浮市",
          name: "黄美灵",
          weixin: "13709656307",
          QQ: "2850259785",
          dianhua: "0757-85101650",
        },
        {
          quyu: "鹤泰路,河源市,梅州市,潮州市",
          name: "林常梅",
          weixin: "13726306502",
          QQ: "2850259784",
          dianhua: "0757-85101650",
        },
        {
          quyu: "东莞市",
          name: "曹康旭",
          weixin: "13709656215",
          QQ: "2851704829",
          dianhua: "0757-86775702",
        },
        {
          quyu: "佛山市,韶关市,惠州市,茂名市,湛江市",
          name: "赖家红",
          weixin: "13702655061",
          QQ: "2851704856",
          dianhua: "0757-86775702",
        },
        {
          quyu: "深圳市",
          name: "温火生",
          weixin: "13702258392",
          QQ: "2851704593",
          dianhua: "0757-86775702",
        },
        // {
        //   quyu: "",
        //   name: "林丽欣",
        //   weixin: "13726323720",
        //   QQ: "2851704855",
        //   dianhua: "0757-86775702",
        // },
        {
          quyu: "中山市,珠海市,清远市,江门市,肇庆市",
          name: "杜婷",
          weixin: "17322721831",
          QQ: "2851704592",
          dianhua: "0757-86775702",
        },
        // {
        //   quyu: "",
        //   name: "岑锡媚",
        //   weixin: "13392796863",
        //   QQ: "2851704591",
        //   dianhua: "0757-86775702",
        // },
      ],
    };
  },
  methods: {
    // QQ交谈
    func_qq(event) {
      const qq = event.currentTarget.dataset.qq;
      if (qq) {
        window.open("tencent://message/?uin=" + qq);
      }
    },
  },
  mounted() {},
};
</script>
<style src='@/style/contactWay.css' scoped></style>
<style src='@/style/contactWay-h5.css' scoped></style>



// WEBPACK FOOTER //
// src/pages/ContactWay.vue